import React from 'react';
import BackButton from '../components/BackButton';
import { useAppContext } from '../AppContext';

const AboutUsPage: React.FC = () => {
    const { appConfig } = useAppContext();

    return (
        <div className="space-y-4">
            <BackButton />
            <div className="bg-white p-6 rounded-lg shadow-sm space-y-4 text-gray-700">
                <div className="text-center">
                    {appConfig.logoUrl && <img src={appConfig.logoUrl} alt="App Logo" className="w-24 h-24 mx-auto mb-4" referrerPolicy="no-referrer" />}
                    <h1 className="text-3xl font-bold">
                        <span className="aurora-text">What Was It?</span>
                    </h1>
                    <p className="text-gray-500 font-semibold">Version {__APP_VERSION__}</p>
                </div>
                
                <div>
                    <h2 className="font-bold text-lg text-gray-800 border-b pb-1 mb-2">Our Mission</h2>
                    <p>
                        Welcome to "What Was It?", the ultimate social guessing game designed to challenge your perception and connect you with friends and family. Our mission is to create a fun, engaging, and creative community where users can share their unique perspectives of the world through visual puzzles.
                    </p>
                </div>

                <div>
                    <h2 className="font-bold text-lg text-gray-800 border-b pb-1 mb-2">How It Works</h2>
                    <p>
                        Post a picture of anything—an object, a place, a person, a scene from a movie—but with a twist! Use our powerful in-app editor to crop, filter, and frame your image to make it a fun challenge. Add a cryptic clue, and watch as your friends and the community try to guess what it is.
                    </p>
                </div>

                 <div>
                    <h2 className="font-bold text-lg text-gray-800 border-b pb-1 mb-2">Features</h2>
                    <ul className="list-disc list-inside space-y-1">
                        <li><strong>Powerful Image Editor:</strong> Dozens of filters, frames, and effects to create the perfect puzzle.</li>
                        <li><strong>AI-Powered Tools:</strong> Use AI to generate clever clues or even create unique images from your imagination.</li>
                        <li><strong>Social & Groups:</strong> Follow friends, create private groups, and compete on leaderboards.</li>
                        <li><strong>Endless Content:</strong> Explore categories, daily challenges, and a global feed of user-created puzzles.</li>
                    </ul>
                </div>
                
                <div>
                    <h2 className="font-bold text-lg text-gray-800 border-b pb-1 mb-2">Contact Us</h2>
                    <p>
                        Have a question, a suggestion, or a problem? Please use the "Report a Problem" feature in the Settings menu to talk to our AI Support Assistant.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AboutUsPage;